import { SAVE_USER } from '../constants/event.actionTypes.js'

/**
 * NOTE: This structure matches the account details return schema from resi-pal.
 */
const initialState = {
  logged_in: false,
  first_name: '',
  last_name: '',
  user_id: 0,
  has_listing: false,
  has_non_auction_listing: false,
  buyer_offer: false,
  address: '',
  assets_owned: 0,
  city: '',
  country: '',
  country_id: 0,
  mobile: '',
  phone: '',
  primary_role: 0,
  seller_codes: [],
  state_code: '',
  state_id: 0,
  title: '',
  zip: '',
}

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case SAVE_USER:
      return Object.assign({}, state, action.value)
    default:
      return state
  }
}

export default userReducer
export { initialState }
